import { unreachable } from '../../../../ts-utils';
import { TRY_OPEN_COMMENT_BOX, TRY_CLOSE_ALL_COMMENT_BOXES } from './comment-box-actions';
import { SHOW_TOAST } from './show-toast-action';
export const effectsReducer = (state, action) => {
    if (state.componentState === 'HIDDEN') {
        return state;
    }
    switch (action.type) {
        case TRY_OPEN_COMMENT_BOX:
            return {
                ...state,
                effects: {
                    ...state.effects,
                    commentBox: {
                        type: 'open',
                        shouldScroll: action.payload.shouldScroll ?? false,
                        shouldFocus: action.payload.shouldFocus ?? false,
                    },
                },
            };
        case TRY_CLOSE_ALL_COMMENT_BOXES:
            return { ...state, effects: { ...state.effects, commentBox: { type: 'close' } } };
        case SHOW_TOAST:
            return {
                ...state,
                effects: {
                    ...state.effects,
                    toast: {
                        skin: action.payload.skin,
                        message: action.payload.message,
                        timestamp: Date.now(),
                    },
                },
            };
        default:
            throw unreachable(action);
    }
};
//# sourceMappingURL=effects-reducer.js.map